<div class="width-1200">


  <mat-toolbar class="toolbar-top">

    <div class='title'>
      <mat-icon>mobile_friendly</mat-icon>
      <div style='font-size: 17px;'>
        Inscrições
      </div>

      <!--
      <a mat-button (click)="loadAllOrders()" style='width:60px;'>
        load All orders
      </a>
      -->

    </div>

  </mat-toolbar>

  <mat-tab-group id='tabs'>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>mobile_friendly</mat-icon>
        Inscrições
      </ng-template>

      <mat-card style="display: flex; flex-direction: row; justify-content: flex-start;">

        <mat-select (ngModelChange)='selectOrdersByProduct($event)' [ngModel]='selectedProduct.id'
          placeholder="Selecione um produto">
          <mat-option *ngFor="let product of arrayProducts" [value]="product.id">
            {{ product.name }}
          </mat-option>
        </mat-select>

      </mat-card>

    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class='tab-icon'>mobile_friendly</mat-icon>
        Histórico
      </ng-template>

      <mat-card style="display: flex; flex-direction: row; justify-content: flex-start;">

        <mat-select (ngModelChange)='selectOrdersByProduct($event)' [ngModel]='selectedProduct.id'
          placeholder="Selecione um produto">
          <mat-option *ngFor="let product of arrayProductsHistoric" [value]="product.id">
            {{ product.name }}
          </mat-option>
        </mat-select>

      </mat-card>

    </mat-tab>

  </mat-tab-group>


  <mat-card>

    <div style="padding: 15px; font-size: 1.2em; width: 95%; background-color: whitesmoke; margin-bottom: 10px;;">
      {{local_title}}
    </div>

    <div *ngIf="ngFlag"
      style="display: flex; flex-direction: row; justify-content:space-between; padding: 0 10px 10px 10px;">

      <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro' autocomplete="off">

      <div style="margin-top: 5px;">

        <span class='head-number'>
          {{ countOrdered }}
        </span>

        <span class='head-number'>
          {{totalOrdered | currency:'BRL':'':'1.2-2' }}
        </span>

        <span class='head-number'>
          {{totalOrdered_minus_tax | currency:'BRL':'':'1.2-2' }}
        </span>


      </div>

      <div>

        <button mat-button style='width:40px;' (click)="exportToCsv()">
          <mat-icon class='icon-close'>arrow_circle_down</mat-icon>
        </button>

        <button mat-button style='width:40px;' (click)="openFailDialog()">
          <mat-icon class='icon-delete'>error</mat-icon>
        </button>

        <button mat-button style='width:40px;' (click)="openDialog(null)">
          <mat-icon class='icon-add'>add_circle_outline</mat-icon>
        </button>

      </div>

    </div>

    <!-- TABLE -->
    <mat-table [dataSource]="orderedDataSource" matSort *ngIf="ngFlag">
      <!-- date Column -->
      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div *ngIf='element.date'>
            <div>
              {{ element.date.seconds*1000 | date: 'dd/MM/yyyy' }}
            </div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div style="margin: 0 5px 0 5px;">
            <div class="div-line">{{ element.member_name }}</div>
            <div class="div-line">{{ element.category_name }}</div>
            <div *ngIf="element.topic_name" class="div-line">{{ element.topic_name.substring(0, 34) }}...</div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="payment">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Pagamento </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <div class="div-line">{{ element.payment_type }}<span class="div-line" *ngIf="element.card_brand"> /
                {{element.card_brand }}</span></div>
            <div class="div-line" *ngIf='element.Tid '>{{ element.Tid }}</div>
            <div class="div-line">{{ element.origin }}</div>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="debit">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Débito </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.member_debit | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="discount">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Desconto </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.discount | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tax">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Taxa </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.tax }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="value">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Valor </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.value | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="total">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Total </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.total | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="total_minus_tax">
        <mat-header-cell *matHeaderCellDef mat-sort-header> Líquido </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.total_minus_tax | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
      </ng-container>

      <!-- edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button (click)='openViewerDialog(element)' style='background-color: whitesmoke;'>
            <mat-icon class='icon-info' style='font-size:1.5em;'>
              info_outline
            </mat-icon>
          </a>
        </mat-cell>
      </ng-container>

      <!-- Header -->
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

      <!-- Footer 
        <mat-row mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></mat-row>
-->
    </mat-table>

  </mat-card>

</div>